import {
  ArrowLeftOutlined,
  ArrowRightOutlined,
  FontSizeOutlined,
  InfoCircleOutlined,
} from "@ant-design/icons";
import {
  Switch,
  Button,
  Card,
  Col,
  Radio,
  Row,
  Select,
  Slider,
  Tooltip,
  Typography,
} from "antd";
import { SliderMarks } from "antd/es/slider";
import React from "react";
import { useNavigate } from "react-router-dom";
import ThemeContextProvider from "../Context/ThemeContext";
import { Utils } from "../../Utilities/Utils";

export interface IThemeData {
  darkMode?: boolean;
  themeColor: string;
  fontSize: number;
  borderRadius: number;
  componentSize: "small" | "middle" | "large" | undefined;
  tablePageSize: number;
  silderSize?: boolean;
  zebraStriped?: boolean;
}

const ThemeSetting = () => {
  const { Text } = Typography;
  const navigate = useNavigate();
  const [onChange, setOnChange] = React.useState<IThemeData>({
    darkMode: false,
    themeColor: "#004B8B",
    fontSize: 14,
    borderRadius: 6,
    componentSize: "middle",
    tablePageSize: 15,
    silderSize: true,
    zebraStriped: true,
  });
  const [data, setData] = React.useState<IThemeData>(onChange);
  const [width, setWidth] = React.useState<any>(window.innerWidth);
  const [trigger, setTrigger] = React.useState<number>(0);

  const fontSizeMarks: SliderMarks = {
    10: "Small",
    14: "Medium",
    18: "Large",
  };
  const borderSizeMarks: SliderMarks = {
    1: "Small",
    6: "Medium",
    12: "Large",
  };
  React.useEffect(() => {
    // console.log(width);
    const handleResize = () => setWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [width]);

  React.useEffect(() => {
    const getThemeLocalData = localStorage.getItem("ci-config");
    if (getThemeLocalData) {
      const data: any = JSON.parse(getThemeLocalData);
      const x = {
        ...data,
        silderSize: data.silderSize ?? false,
      };
      // console.log("useEffect", x);
      setOnChange(x);
      setData(x);
    } else {
      setOnChange({
        darkMode: false,
        themeColor: "#004B8B",
        fontSize: 14,
        borderRadius: 6,
        componentSize: "middle",
        tablePageSize: 15,
        silderSize: true,
        zebraStriped: true,
      });
      setData({
        darkMode: false,
        themeColor: "#004B8B",
        fontSize: 14,
        borderRadius: 6,
        componentSize: "middle",
        tablePageSize: 15,
        silderSize: true,
        zebraStriped: true,
      });
    }
  }, []);

  React.useEffect(() => {
    if (trigger) {
      Utils.setLocal("ci-config", data);
      navigate(-1);
    }
    //  else {
    //  navigate(-1);
    // }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [trigger]);

  const colors = [
    "#432158",
    "#7a0303",
    "#004B8B",
    "#0b3024",
    "#034e5c",
    "#544f4f",
    // "#2196f3",
    "#3a4a52",
  ];

  // Apply or remove zebra striping based on the setting
  React.useEffect(() => {
    const zebraStyleId = "zebra-style";
    let zebraStyleTag = document.getElementById(zebraStyleId);

    if (onChange.zebraStriped) {
      //  create or update zebra style
      if (!zebraStyleTag) {
        zebraStyleTag = document.createElement("style");
        zebraStyleTag.id = zebraStyleId;
        document.head.appendChild(zebraStyleTag);
      }
      zebraStyleTag.innerHTML = `
      /* Apply zebra stripes to all Ant Design tables */
      .ant-table-tbody > tr:nth-child(even) > td {
        background-color: #f7f7f7 !important; 
      }
    `;
    } else {
      //  remove zebra style when turned off
      if (zebraStyleTag) {
        zebraStyleTag.remove();
      }
    }
  }, [onChange.zebraStriped]);

  return (
    <div>
      {/* <div style={{ marginBottom: "16px" }}>
                <Profiletabs />
            </div> */}
      <Row>
        <Col xl={16} sm={14} xs={15}>
          <div>
            {/* --------- Dark Mode ---------*/}
            {/* <Row>
              <Col xl={8} sm={14} xs={15}>
                <Text>Dark Mode</Text>
              </Col>
              <Col xs={7} style={{ textAlign: "end" }}>
                <Switch
                  checked={onChange.darkMode}
                  checkedChildren={<MdDarkMode />}
                  unCheckedChildren={<MdLightMode />}
                  onChange={(value) =>
                    setOnChange({ ...onChange, darkMode: value })
                  }
                />
              </Col>
            </Row> */}

            {/* --------- Font Size ---------*/}
            <Row>
              <Col lg={20} style={{ paddingTop: "15px" }}>
                <Text>
                  Font Size
                  <Tooltip title="You can change font size for whole application.">
                    <InfoCircleOutlined style={{ paddingLeft: "5px" }} />
                  </Tooltip>
                </Text>
              </Col>
            </Row>

            <Col xl={15} sm={15} xs={18}>
              <Slider
                style={{ marginLeft: "15px" }}
                tooltip={{ open: false }}
                marks={fontSizeMarks}
                min={10}
                max={18}
                value={onChange.fontSize}
                onChange={(value: number) =>
                  setOnChange({ ...onChange, fontSize: value })
                }
              />
            </Col>

            {/*--------- Border Redius ---------*/}
            <Col lg={24} style={{ paddingTop: "5px" }}>
              <Text>
                Border Redius
                <Tooltip title="You can change Border size for whole application.">
                  <InfoCircleOutlined style={{ paddingLeft: "5px" }} />
                </Tooltip>
              </Text>
            </Col>
            <Col xl={15} sm={15} xs={18}>
              <Slider
                style={{ marginLeft: "15px" }}
                tooltip={{ open: false }}
                marks={borderSizeMarks}
                min={1}
                max={12}
                value={onChange.borderRadius}
                onChange={(value: number) =>
                  setOnChange({ ...onChange, borderRadius: value })
                }
              />
            </Col>

            {/*---------  Table Page Size(length) ---------*/}
            <Row style={{ paddingTop: "10px" }} align="middle">
              <Col lg={12} sm={14} xs={15}>
                <Text>
                  Default page length
                  <Tooltip title="You can change how many records are display in your table at one time.">
                    <InfoCircleOutlined style={{ paddingLeft: "5px" }} />
                  </Tooltip>
                </Text>
              </Col>
              <Col lg={12} xs={1}>
                <Select
                  style={{ width: "100px" }}
                  value={onChange.tablePageSize}
                  onChange={(value) =>
                    setOnChange({ ...onChange, tablePageSize: value })
                  }
                  options={[
                    { value: 15, label: "15" },
                    { value: 25, label: "25" },
                    { value: 50, label: "50" },
                    { value: 100, label: "100" },
                    { value: 200, label: "200" },
                  ]}
                />
              </Col>
            </Row>

            {/* ---------zebra Striped Table --------- */}

            <Row style={{ paddingTop: "10px" }} align="middle">
              <Col lg={12} sm={14} xs={15}>
                <Text>
                  Striped Table
                  <Tooltip title="Use striped to add zebra-striping to any table row.">
                    <InfoCircleOutlined style={{ paddingLeft: "5px" }} />
                  </Tooltip>
                </Text>
              </Col>
              <Col lg={12} xs={1}>
                <Switch
                  size="default"
                  checked={onChange.zebraStriped}
                  onChange={(value) =>
                    setOnChange({ ...onChange, zebraStriped: value })
                  }
                />
              </Col>
            </Row>

            {/*--------- Theme Color ---------*/}
            <Col style={{ padding: "15px 0px 12px 0px" }}>
              <Text>
                Theme Color
                <Tooltip title="You can change color for whole application.">
                  <InfoCircleOutlined style={{ paddingLeft: "5px" }} />
                </Tooltip>
              </Text>
            </Col>
            {/* <ColorPicker
              style={{ width: "117px", height: "96px" }}
              className="ca-theme-colorPicker"

              presets={[
                {
                  label: "Recommended",
                  colors: [
                    "#432158",
                    "#D43A1C",
                    "#004B8B",
                    "#8D398F",
                    "#008299",
                    "#911844",
                  ],
                },
              ]}
              value={onChange.themeColor}
              onChange={(value) =>
                setOnChange({
                  ...onChange,
                  themeColor:
                    typeof value === "string" ? value : value.toHexString(),
                })
              }
            /> */}

            <div style={{ padding: "20px 0px 20px 0px" }}>
              <h3>Selected Color:</h3>
              {/* <div
                style={{
                  width: "50px",
                  height: "50px",
                  backgroundColor: themeColor,
                  border: "1px solid #ccc",
                }}
              /> */}
              <div
                className="ca-theme-colorPicker"
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  marginTop: "10px",
                  gap: "10px",
                }}
              >
                {colors.map((color) => (
                  <div
                    key={color}
                    style={{
                      width: "50px",
                      height: "50px",
                      backgroundColor: color,
                      border:
                        onChange.themeColor === color
                          ? "3px solid #000"
                          : "1px solid #ccc",
                      cursor: "pointer",
                    }}
                    onClick={() =>
                      setOnChange({
                        ...onChange,
                        themeColor: color, // Directly setting the color
                      })
                    }
                  />
                ))}
              </div>
            </div>

            {/*--------- Silder Menu ---------*/}
            <Col style={{ paddingTop: "15px" }}>
              <Text>
                Default mode for the left Menu
                <Tooltip title="Select between viewing the left menu as a flyout or docked in a larger sized windows.">
                  <InfoCircleOutlined style={{ paddingLeft: "5px" }} />
                </Tooltip>
              </Text>
            </Col>

            <Radio.Group
              disabled={width <= 1024 ? true : false}
              value={onChange.silderSize}
              onChange={(e: any) =>
                setOnChange({ ...onChange, silderSize: e.target.value })
              }
            >
              <Row gutter={12}>
                <Col>
                  <Tooltip
                    open={width <= 1024 ? true : false}
                    title="Can be only enabled on large screen"
                    color={"black"}
                  >
                    <Card className="ca-card-theme">
                      <Radio value={true} style={{ padding: "21px 19px" }}>
                        <div>
                          <ArrowRightOutlined style={{ fontSize: "30px" }} />
                          <p>Deckot</p>
                        </div>
                      </Radio>
                    </Card>
                  </Tooltip>
                </Col>
                <Col>
                  <Tooltip
                    open={width <= 1024 ? true : false}
                    title="Can be only enabled on large screen"
                  >
                    <Card className="ca-card-theme">
                      <Radio value={false} style={{ padding: "21px 18px" }}>
                        <div>
                          <ArrowLeftOutlined style={{ fontSize: "30px" }} />
                          <p>Flyout</p>
                        </div>
                      </Radio>
                    </Card>
                  </Tooltip>
                </Col>
              </Row>
            </Radio.Group>

            {/*---------  Component Size ---------*/}
            <Col style={{ paddingTop: "15px" }}>
              <Text>
                Component Size
                <Tooltip title="You can change Component size for whole application.">
                  <InfoCircleOutlined style={{ paddingLeft: "5px" }} />
                </Tooltip>
              </Text>
            </Col>

            <Radio.Group
              value={onChange.componentSize}
              onChange={(e: any) =>
                setOnChange({ ...onChange, componentSize: e.target.value })
              }
            >
              <Row gutter={10}>
                <Col>
                  <Card className="ca-card-theme">
                    <Radio value="small" style={{ padding: "26px 25px" }}>
                      <div>
                        <FontSizeOutlined style={{ fontSize: "20px" }} />
                        <p>Small</p>
                      </div>
                    </Radio>
                  </Card>
                </Col>

                <Col>
                  <Card className="ca-card-theme">
                    <Radio value="middle" style={{ padding: "19px 15px" }}>
                      <div>
                        <FontSizeOutlined style={{ fontSize: "35px" }} />
                        <p>Medium</p>
                      </div>
                    </Radio>
                  </Card>
                </Col>
                <Col>
                  <Card className="ca-card-theme">
                    <Radio value="large" style={{ padding: "12px 14px" }}>
                      <div>
                        <FontSizeOutlined style={{ fontSize: "50px" }} />
                        <p>Large</p>
                      </div>
                    </Radio>
                  </Card>
                </Col>
              </Row>
            </Radio.Group>

            {/*---------  Sumbit Button ---------*/}
            <Row style={{ paddingTop: "20px" }}>
              <Col lg={12} sm={12} xs={10}>
                {/* <Button
                  type="dashed"
                  onClick={() => {
                    setTrigger(true);
                    setData({
                      darkMode: false,
                      themeColor: "#004B8B",
                      fontSize: 14,
                      borderRadius: 6,
                      componentSize: "middle",
                      tablePageSize: 15,
                      silderSize: true,
                    });
                  }}
                >
                  Default Theme
                </Button> */}
              </Col>
              <Col lg={12} sm={8} xs={12}>
                <Button
                  style={{ marginRight: "10px" }}
                  onClick={() => {
                    setTrigger((x) => x + 1);
                  }}
                >
                  Cancel
                </Button>
                <Button
                  type="primary"
                  onClick={() => {
                    setData(onChange);
                    setTrigger((x) => x + 1);
                  }}
                >
                  Save
                </Button>
              </Col>
            </Row>
          </div>
          {/* {trigger === true &&
            (localStorage.setItem("ci-config", JSON.stringify(data)),
              navigate("/books"))}
          {trigger === false && navigate("/books")} */}

          {data && <ThemeContextProvider data={data} />}
        </Col>
      </Row>
    </div>
  );
};

export default ThemeSetting;

export const tablePageSizeOptions = ["15", "25", "50", "100", "200"];
